import { BoxProps, TabsProps } from '@mui/material'
import { Box, Tabs } from '@elphasecure/elpha-design-system'
import { styled } from '@mui/material/styles'

const ThemedMuiTabs = styled(Tabs)<TabsProps>(({ theme }) => ({
  ' & .MuiTab-root': {
    textColor: theme.palette.primary[400],
    textColorPrimary: theme.palette.primary.main,
    ...(theme.typography as any).bodyLarge,
    paddingLeft: 0,
    paddingRight: 0,
    marginRight: '40px',
    minWidth: '10px',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}))

// ThemedTabs Props
export interface ThemedTabsProps {
  tabProps?: TabsProps
  containerProps?: BoxProps
  children: React.ReactNode
  value?: number | string
}

export const ThemedTabs = (props: ThemedTabsProps) => {
  return (
    <Box
      sx={{
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'primary.300',
      }}
      {...props.containerProps}
    >
      <ThemedMuiTabs {...props.tabProps} value={props.value}>
        {props.children}
      </ThemedMuiTabs>
    </Box>
  )
}
